export default __webpack_public_path__ + "static/media/UGLY ANGELS.a723c654.png";